var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"danger justify-content-center align-items-center p-0 text-nowrap flex-nowrap",class:_vm.$style.btn,attrs:{"type":"button"}},_vm.$listeners),[_c('app-icon',{attrs:{"name":"close-3"}}),_vm._v("\n    "+_vm._s(_vm.$t("input.resetFilters"))+"\n  ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }